<form-layout
    [showSave]="canSave"
    (onSave)="onSaveClick()"
    (onBack)="onBackClick()"
    (onNext)="onSaveAndNextClick()">
    
    <stipendium [form]="stipendiumProcessStepForm"></stipendium>
</form-layout>
